<template>
	<div class="container page">
		<van-nav-bar :title="videoInfo.title" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="movie-video">
			<video v-if="videoType === 'mp4'" controls class="video-js">
				<source :src="videoInfo.film" type="video/mp4">
				Su navegador no soporta la etiqueta de vídeo HTML5.
			</video>
			<!-- M3U8 使用 hls.js 播放 -->
			<video v-if="videoType === 'm3u8'" ref="hlsVideo" controls class="video-js"></video>
		</div>

		<div v-if="videoType === 'iframe'">
			<iframe :src="videoInfo.film" class="video-js" frameborder="0" scrolling="no" allowfullscreen loading="lazy"
				referrerpolicy="no-referrer-when-downgrade"></iframe>
		</div>


		<div class="movie-content">
			<div class="movie-descript">
				<p>{{ videoInfo.title }}</p>
				<span>{{ videoInfo.views }}{{ $t("video.num_play") }}</span>
			</div>

			<div class="movie-body">
				<div class="movie-title">
					<div>
						<span>{{ $t("index.recmonmand") }}</span>
					</div>
				</div>
			</div>
			<div class="hotlist">
				<div class="hotlistS" v-for="(v,key) in moreVideoInfo" :key="key" @click="toPlayVideo(v.id)">
					<img :src="v.image" class="imgBox" />
					<div class="hotlistT">
						<span>{{ v.title }}</span><span>{{$t("video.play")}}:{{ v.views }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Hls from 'hls.js'
	export default {
		data() {
			return {
				hls: null,
				videoType: '', // 'mp4' 或 'm3u8'
				videoInfo: {},
				moreVideoInfo: [],
				id: this.$route.query.id
			};
		},
		mounted() {
			this.getMoreVideoItem();
		},
		beforeDestroy() {
			if (this.hls) {
				this.hls.destroy()
			}
		},
		methods: {
			// extractSrcSimple(iframeString) {
			// 	const start = iframeString.indexOf('src="') + 5;
			// 	const end = iframeString.indexOf('"', start);
			// 	return iframeString.substring(start, end);
			// },
			initHlsPlayer() {
				if (Hls.isSupported()) {
					const hls = new Hls();
					hls.loadSource(this.videoInfo.film);
					hls.attachMedia(this.$refs.hlsVideo);
					hls.on(Hls.Events.MANIFEST_PARSED, () => {
						this.$refs.hlsVideo.play();
					});
				} else if (this.$refs.hlsVideo.canPlayType('application/vnd.apple.mpegurl')) {
					// Safari 原生支持
					this.$refs.hlsVideo.src = this.videoInfo.film;
					this.$refs.hlsVideo.addEventListener('loadedmetadata', () => {
						this.$refs.hlsVideo.play();
					});
				}
			},
			back() {
				return window.history.back();
			},
			toPlayVideo(id) {
				this.$router.push({
					path: "/PlayVideo",
					query: {
						id
					}
				});
				location.reload();
			},
			//视频详情
			getMoreVideoItem() {
				this.$http({
					method: "get",
					url: "getFilmInfo",
					data: {
						film_id: this.id
					}
				}).then((res) => {
					this.moreVideoInfo = res.data.list;
					console.log(this.moreVideoInfo, '54454')
					this.videoInfo = res.data.info
					this.videoType = res.data.info.type;
					// this.initHlsPlayer()
					// 必须等 Vue 完成 DOM 更新
					this.$nextTick(() => {
						if (this.videoType === 'm3u8') {
							this.initHlsPlayer();
						}
					});
				});
			},
		},
	}
</script>

<style lscoped lang="less">
	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	::v-deep .mediaplayer_wrapper {
		width: 300px !important;
	}

	.video-js {
		width: 100%;
		height: 420px;
		font-size: 24px;
	}

	.movie-content {
		flex: 1;
	}

	.movie-content .movie-descript {
		width: 100%;
		/* height: 140px; */
		background-color: #fff;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
		padding: 15px;
	}

	.movie-content .movie-descript p {
		font-size: 30px;
		font-weight: 700;
		color: rgb(62, 33, 134);
	}

	.movie-content .movie-descript span {
		color: rgb(170, 45, 220);
		font-size: 0.8rem;
		background: rgb(242, 242, 245);
		padding: 10px;
		border-radius: 16px;
	}

	.movie-content .movie-body {
		width: calc(100% - 20px);
		margin: 0 auto;
	}

	::v-deep .movie-video .video-js .vjs-big-play-button {
		top: 50%;
		left: 50%;
		margin-top: -50px;
		margin-left: -100px;
	}

	.movie-content .movie-body .movie-title {
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.movie-content .movie-body .movie-title>div:first-child {
		width: 410px;
	}

	.movie-content .movie-body .movie-title>div:first-child span {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-size: 30px;
		font-weight: 700;
		color: #000;
	}

	.movie-content .movie-body .movie-title>div:first-child span:before {
		content: "";
		display: block;
		width: 8px;
		height: 30px;
		background-color: #7e5678;
		border-radius: 25px;
		margin-right: 10px;
	}

	abbr,
	address,
	article,
	aside,
	audio,
	b,
	blockquote,
	body,
	canvas,
	caption,
	cite,
	code,
	dd,
	del,
	details,
	dfn,
	div,
	dl,
	dt,
	em,
	fieldset,
	figcaption,
	figure,
	footer,
	form,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	header,
	hgroup,
	html,
	i,
	iframe,
	img,
	ins,
	kbd,
	label,
	legend,
	li,
	mark,
	menu,
	nav,
	object,
	ol,
	p,
	pre,
	q,
	samp,
	section,
	small,
	span,
	strong,
	sub,
	summary,
	sup,
	table,
	tbody,
	td,
	tfoot,
	th,
	thead,
	time,
	tr,
	ul,
	var,
	video {
		margin: 0;
		padding: 0;
		border: 0;
		outline: 0;
		font-size: 100%;
		vertical-align: baseline;
		box-sizing: border-box;
	}

	.vjs-big-play-button .vjs-icon-placeholder {
		font-size: 1.63em !important;
	}



	.hotlist {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		.hotlistS {
			position: relative;
			border-radius: 16px;
			overflow: hidden;
			margin-bottom: 20px;

			.imgBox {
				object-fit: cover;
				width: 100%;
				height: 27vw;
			}

			.hotlistT {
				position: absolute;
				bottom: 0px;
				width: 100%;
				left: 0;
				background: rgba(0, 0, 0, .4);
				color: #fff;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-size: 3vw;
				height: 8vw;
				border-radius: 16px 16px 0 0;

				span {
					width: 50%;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					text-align: center;
					padding-left: 20px;
				}
			}
		}
	}
</style>